import React, { useCallback, useEffect, useState } from 'react';
import api from '@common/utils/api';
const MiniPromo = React.lazy(() => import(/* webpackChunkName: "component-editorial-module" */ '@moncler/components/product/experience/MiniPromo'));
const EditorialModule = React.lazy(() => import(/* webpackChunkName: "component-editorial-module" */ '@moncler/components/product/experience/EditorialModule'));
const EditorialVideoPDP = React.lazy(() => import(/* webpackChunkName: "component-editorial-video" */ '@moncler/components/product/experience/EditorialVideoPDP'));
const DetailsSlider = React.lazy(() => import(/* webpackChunkName: "component-details-slider" */ '@moncler/components/product/experience/DetailsSlider'));
const DetailSlide = React.lazy(() => import(/* webpackChunkName: "component-details-slide" */ '@moncler/components/product/experience/DetailSlide'));
const VideoQuote = React.lazy(() => import(/* webpackChunkName: "component-video-quote" */ '@moncler/components/product/experience/VideoQuote'));
const editorialContentConfig = {
    component_pdp_mini_promo: MiniPromo,
    component_pdp_editorial_module: EditorialModule,
    component_pdp_editorial_video: EditorialVideoPDP,
    component_pdp_details_slider: DetailsSlider,
    component_pdp_details_slide: DetailSlide,
    component_pdp_editorial_video_quote: VideoQuote,
};
const getEditorialComponent = (content) => {
    if (!editorialContentConfig[content.typeid]) {
        console.error(`Editorial component ${content.typeid} not found`);
        return React.createElement(React.Fragment, null);
    }
    const Component = editorialContentConfig[content.typeid];
    let componentregionprops = [];
    if (content.regions) {
        const regions = Object.values(content.regions);
        componentregionprops = regions[0].components.map((component, index) => {
            return getEditorialComponent(component);
        });
    }
    const props = Object.assign(Object.assign(Object.assign(Object.assign({}, content), content.image), content.other), { componentregionprops });
    return React.createElement(Component, Object.assign({}, props));
};
const useProductEditorialContents = (props) => {
    const { pid, setDetailsOpen, product, pdContent, isEditMode } = props;
    const [promoSection, setPromoSection] = useState(null);
    const [bottomSectionComponent, setBottomSectionComponents] = useState(null);
    const resetEditorials = () => {
        setPromoSection(null);
        setBottomSectionComponents(null);
    };
    const setPageDesignerContent = useCallback((regions) => {
        var _a;
        if (regions) {
            if (regions.promobanner && regions.promobanner.components && ((_a = regions.promobanner.components) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setPromoSection(getEditorialComponent(regions.promobanner.components[0]));
            }
            if (regions.bottom && regions.bottom.components && regions.bottom.components.length) {
                const bottomRegionComponents = regions.bottom.components.map((component) => {
                    return getEditorialComponent(Object.assign(Object.assign({}, component), { other: { setDetailsOpen } }));
                });
                setBottomSectionComponents(bottomRegionComponents);
            }
        }
    }, []);
    useEffect(() => {
        if (isEditMode) {
            api.getPageJson(`${pid}`, false).then((data) => {
                if (data.page) {
                    const { regions } = data.page;
                    resetEditorials();
                    setPageDesignerContent(regions);
                }
            });
        }
        else {
            resetEditorials();
            if (pdContent && pdContent != 'null') {
                const { regions } = JSON.parse(pdContent);
                setPageDesignerContent(regions);
            }
        }
    }, [pdContent, pid]);
    const BottomSection = useCallback(() => {
        return React.createElement("div", null, bottomSectionComponent && bottomSectionComponent.map((Section, index) => React.createElement("div", { key: index + pid }, Section)));
    }, [bottomSectionComponent, pid]);
    return {
        promoSection,
        BottomSection,
    };
};
export default useProductEditorialContents;
